<template>
  <b-row>
    <b-col sm="12">
      <b-card header="Listado de tanqueo">
        <div class="form-group form-inline pull-left">
          <input v-model="search" type="search" class="form-control" placeholder="Buscar" /> &nbsp;
        </div>
        <div class="form-group form-inline pull-right">
          <form @submit.prevent="getRefuelings">
            <date-picker
              v-model="date.start"
              lang="es"
              type="date"
              placeholder="Desde"
              required
              format="DD/MM/YYYY"
            ></date-picker>&nbsp;
            <date-picker
              v-model="date.end"
              lang="es"
              type="date"
              placeholder="Hasta"
              required
              format="DD/MM/YYYY"
            ></date-picker>&nbsp;
            <input type="submit" class="btn btn-primary" value="Buscar" />&nbsp;
          </form>
          <download-excel
              class="btn btn-primary"
              :data="filteredRefuelings"
              :fields="json_fields"
              name="Combustible.xls"
            >Descargar Excel
          </download-excel>&nbsp;
          <button
            v-if="user.role.code === constants.ABASTECEDOR"
            @click="newFuel"
            type="button"
            class="btn btn-primary"
          >Nuevo</button>&nbsp;
        </div>
        <div class="table-responsive">
          <table class="table table-striped table-hover table-bordered">
            <thead>
              <tr>
                <th>Fecha</th>
                <th>Lugar de abastecimiento</th>
                <th>Nombre operario</th>
                <th>Placa</th>
                <th>Tipo de unidad</th>
                <th>Operación</th>
                <th>Proveedor</th>
                <th>Equipo</th>
                <th>Responsable</th>
                <th>Galonaje</th>
                <th>Kilometraje</th>
                <th>Guía de remisión</th>
                <th>Número de vale</th>
                <th>Precio unitario</th>
                <th>Venta</th>
                <th>IGV</th>
                <th>Total</th>
                <th>Comprobante</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(refueling, k) in paginated('filteredRefuelings')" :key="k" @contextmenu.prevent="selectRefuel(refueling)">
                <td>{{refueling.created_at | formatDateTime}}</td>
                <td>{{refueling.supply_place}}</td>
                <td>{{refueling.operator_name}}</td>
                <td>{{refueling.truck ? refueling.truck.plate: '-'}}</td>
                <td>{{refueling.truck && refueling.truck.truck_mode ? refueling.truck.truck_mode.name : ''}}</td>
                <td>{{refueling.truck && refueling.truck.service ? refueling.truck.service.name : '' }}</td>
                <td>{{refueling.truck && refueling.truck.provider ? refueling.truck.provider.name : '' }}</td>
                <td>{{refueling.truck && refueling.truck.team ? refueling.truck.team.name : '' }}</td>
                <td>{{refueling.driver.name}} {{refueling.driver.last_name}}</td>
                <td>{{refueling.gallons}}</td>
                <td>{{refueling.km}}</td>
                <td>{{refueling.number_guide}}</td>
                <td>{{refueling.number_ticket}}</td>
                <td>{{refueling.price_gallons}}</td>
                <td>{{ (refueling.price_gallons*refueling.gallons).toFixed(1) }}</td>
                <td>{{ ((refueling.price_gallons*refueling.gallons)*0.18).toFixed(2) }}</td>
                <td>{{ ((refueling.price_gallons*refueling.gallons)*1.18).toFixed(2) }}</td>
                <td>
                  <button
                    v-if="refueling.voucher"
                    @click="select(refueling.voucher)"
                    type="button"
                    class="btn btn-primary"
                    data-toggle="modal"
                    data-target="#exampleModal"
                  >
                    <i class="fa fa-camera"></i>
                  </button>
                  <div v-else>-</div>
                </td>
              </tr>
            </tbody>
          </table>
          
          <context-menu id="context-menu" ref="ctxMenu">
            <li @click="editRefuel()" class="ctx-item">Editar</li>
          </context-menu>

          <paginate
            name="filteredRefuelings"
            :list="filteredRefuelings"
            class="paginate-list"
            :per="10"
          ></paginate>
          <paginate-links
            for="filteredRefuelings"
            :limit="5"
            :show-step-links="true"
            :step-links="{
                next: '>>',
                prev: '<<'
              }"
            :classes="{
                'ul': 'pagination',
                'li': 'page-item',
                'a': 'page-link',
              }"
          ></paginate-links>
        </div>
      </b-card>
    </b-col>
    <Modal :showModal="showModal" :voucher="voucher" @close="showModal = false" />
    <ModalForm :showModalForm="showModalForm" :refueling_id="refueling_id" @close="showModalForm = false" @update="updateRefueling" />
    <div v-if="showModal || showModalForm" class="modal-backdrop fade show"></div>
  </b-row>
</template>

<script>
import Modal from "./Modal";
import ModalForm from "./ModalForm";
import api from "@/helpers/api";
import s3 from "@/helpers/aws";
import moment from 'moment';
import { mapGetters } from "vuex";
import constants from "@/constants";

export default {
  components: { Modal, ModalForm },
  data() {
    return {
      json_fields: {
        'Fecha': {
          field: 'created_at',
          callback: date => {
            return moment(date).format("DD/MM/YYYY HH:mm")
          }
        },
        'Lugar de abastecimiento': 'supply_place',
        'Nombre operador': 'operator_name',
        'Placa': 'truck.plate',
        'Tipo de unidad': 'truck.truck_mode.name',
        'Operacion': 'truck.service.name',
        'Proveedor': 'truck.provider.name',
        'Equipo': 'truck.team.name',
        'Galones': 'gallons',
        'Odometro': 'km',
        'Guia Remision': 'number_guide',
        'Numero Vale': 'number_ticket',
        'Precio unitario': 'price_gallons',
        'Valor venta': {
          callback: fuel => { return fuel.price_gallons*fuel.gallons }
        },
        'IGV': {
          callback: fuel => { return (fuel.price_gallons*fuel.gallons)*0.18.toFixed(2) }
        },
        'Total': {
          callback: fuel => { return (fuel.price_gallons*fuel.gallons)*1.18.toFixed(2) }
        }
      },
      price: 0,
      refuelings: [],
      showModal: false,
      showModalForm: false,
      refueling_id: null, 
      paginate: ["filteredRefuelings"],
      search: "",
      image: "",
      voucher: "",
      date: {
        start: moment().add(-7, 'days').format('YYYY-MM-DD 00:00:00'),
        end: moment().format('YYYY-MM-DD 23:59:59')
      },
      constants
    };
  },
  mounted() {
    this.getRefuelings()
  },
  computed: {
    ...mapGetters({ user: "user/user" }),
    filteredRefuelings() {
      return this.refuelings.filter(refueling => {
        let condition = true
        
        if(this.search){
          let text = this.search.toLowerCase()
          condition = refueling.truck.plate.toLowerCase().includes(text) ||
                      (refueling.number_guide ? refueling.number_guide.toLowerCase().includes(text) : false) ||
                      (refueling.number_ticket ? refueling.number_ticket.toLowerCase().includes(text) : false)
        }
        return condition
      });
    }
  },
  methods: {
    getRefuelings(){
      api.get(`/refuelings/${moment(this.date.start).format('YYYY-MM-DD')}/${moment(this.date.end).format('YYYY-MM-DD')}`).then(response => {
        this.refuelings = response.refuelings;
      });
    },
    newFuel() {
      this.$router.push({
        path: "/fleet/fuel/new"
      });
    },
    send(){
      
    },
    selectRefuel(refueling){
      this.refueling_id = refueling.id
      this.$refs.ctxMenu.open();
    },
    editRefuel(){
      this.showModalForm = true
    },
    select(voucher) {
      this.showModal = !this.showModal;

      const url = s3.getSignedUrl("getObject", {
        Bucket: `${process.env.VUE_APP_AWS_BUCKET}/refueling`,
        Key: voucher,
        Expires: 60
      });
      this.voucher = url;
    },
    updateRefueling(refueling){
      this.showModalForm = false
      console.log('aca', refueling)
      this.refueling_id = null
      let index = this.refuelings.findIndex(r => r.id == refueling.id)
      this.refuelings.splice(index, 1, refueling)
    }
  }
};
</script>
